Tracking = function( dispatcher ) {
	/*---------------------------------------------------
		VARIABLES 
	--------------------------------------------------*/
	
	this.dispatcher = ( dispatcher !== undefined ) ? dispatcher : new Dispatcher();
	
	/*--------------------------------------------------*/
	
	this.init();

};

Tracking.prototype = {

	constructor : Tracking,
	

	/*-------------------------------------------------
		INITIALIZER
	--------------------------------------------------*/
	init : function(){
		this.bindEvents();
	},
	
	bindEvents : function(){
		this.dispatcher.addEventListener( EVENTS.TRACKING_PAGE, this.onTrackPage.bindX( this ) );
		this.dispatcher.addEventListener( EVENTS.TRACKING_CLICK, this.onTrackClick.bindX( this ) );
	},

	/*-------------------------------------------------
		EVENT HANDLERS
	--------------------------------------------------*/
	
	onTrackClick : function( e , data ){
		try{
			sCode.trackOutboundClick( 'targetURL' , data );
		}
		catch (err) {}
		ga('send', 'event', data, data, 'T2Poster');
	},

	onTrackPage : function( e , data){
		try{
			sCode.trackPageView( data );
		}
		catch (err) {}
		ga('send', 'event', data, data, 'T2Poster');
	}

};


